import { render, staticRenderFns } from "./modal-more-detail.vue?vue&type=template&id=83774914&scoped=true"
import script from "./modal-more-detail.vue?vue&type=script&lang=js"
export * from "./modal-more-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83774914",
  null
  
)

export default component.exports